import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../auth/AuthContext";

export default function GiftTrialPopup() {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
const { t } = useTranslation();
const { user } = useAuth();

  useEffect(() => {
    // Don't show again if already closed
    if (localStorage.getItem("giftTrialPopupSeen")) return;

    const timer = setTimeout(() => {
      setVisible(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  const closePopup = () => {
    localStorage.setItem("giftTrialPopupSeen", "true");
    setVisible(false);
  };

  const register = () => {
    localStorage.setItem("giftTrialPopupSeen", "true");
    navigate("/register");
  };

  if (!visible) return null;

if (user) return null;

return (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.45)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
    }}
  >
    <div
      style={{
        width: 340,
        background: "#fff",
        borderRadius: 16,
        boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
        padding: 20,
      }}
    >
      {/* Title */}
      <div
        style={{
          fontSize: 22,
          fontWeight: 700,
          marginBottom: 10,
        }}
      >
        🎁 {t("giftPopup.title")}
      </div>

      {/* Description */}
      <div
        style={{
          fontSize: 17,
          color: "#444",
          lineHeight: 1.6,
          marginBottom: 18,
        }}
      >
        {t("giftPopup.description")}
      </div>

      {/* Buttons */}
      <div
        style={{
          display: "flex",
          gap: 10,
        }}
      >
        <button
          onClick={() => {
            localStorage.setItem("giftTrialPopupSeen", "true");
            navigate("/signup");
          }}
          style={{
            flex: 1,
            padding: "12px 18px",
            background: "#2563eb",
            color: "#fff",
            border: "none",
            borderRadius: 10,
            cursor: "pointer",
            fontWeight: 600,
          }}
        >
          {t("giftPopup.signup")}
        </button>

        <button
          onClick={closePopup}
          style={{
            flex: 1,
            padding: "12px 18px",
            background: "#f3f4f6",
            border: "none",
            borderRadius: 10,
            cursor: "pointer",
            fontWeight: 600,
          }}
        >
          {t("giftPopup.gotIt")}
        </button>
      </div>
    </div>
  </div>
 );
}
